// @ts-nocheck
import { isArray, isUndefined } from "lodash";
import { getCssVariableHandler } from "../styles/getCssVariables";

export const getTotalLength = (totalLength, dateChangedIdx, sessions) => {
  if (!totalLength || !dateChangedIdx || !sessions) return 0;
  let length = totalLength;
  sessions?.forEach((ses) => {
    if (dateChangedIdx[ses]) {
      Object.entries(dateChangedIdx?.[ses])?.forEach(([_, value]) => {
        if (value?.status) {
          totalLength -= value?.count - 1;
        }
      });
    }
  });
  return length;
};

// export const getDisabledList = ({
//   rows,
//   dateChangedIdx,
//   selectedSession,
//   rowsPerPage,
//   getPosName,
// }) => {
//   if (!rowsPerPage || !rows || !dateChangedIdx) return false;
//   let disabledPages = [];
//   const totalPages = parseInt(rows?.length / rowsPerPage);
//   Array.from({ length: totalPages + 1 })?.forEach((_, page) => {
//     let isDisable = false;
//     rows
//       ?.slice(
//         page * rowsPerPage,
//         Math.min(page * rowsPerPage + rowsPerPage, rows?.length),
//       )
//       ?.every((row, index) => {
//         const posName = getPosName(row);
//         const { status, startIdx } =
//           dateChangedIdx?.[selectedSession]?.[posName] || {};
//         if (status && startIdx !== index + page * rowsPerPage) {
//           isDisable = true;
//         } else {
//           isDisable = false;
//           return false;
//         }
//         return true;
//       });
//     if (isDisable) {
//       disabledPages.push(page + 1);
//       isDisable = false;
//     }
//   });
//   return disabledPages;
// };

export const getDisabledList = ({
  rows,
  dateChangedIdx,
  selectedSession,
  rowsPerPage,
  getPosName,
}) => {
  if (!rowsPerPage || !rows || !dateChangedIdx) return false;

  let disabledPages = [];
  const totalPages = parseInt(rows?.length / rowsPerPage);

  Array.from({ length: totalPages + 1 }).forEach((_, page) => {
    let isDisable = false;

    rows
      ?.slice(
        page * rowsPerPage,
        Math.min(page * rowsPerPage + rowsPerPage, rows?.length),
      )
      ?.every((row, index) => {
        const posName = getPosName?.(row);
        let isStatusInvalid;

        if (isArray(selectedSession)) {
          const { status, startIdx } =
            dateChangedIdx?.[row?.session?._id]?.[posName] || {};
          isStatusInvalid = status && startIdx !== index + page * rowsPerPage;
        } else {
          const { status, startIdx } =
            dateChangedIdx?.[selectedSession]?.[posName] || {};
          isStatusInvalid = status && startIdx !== index + page * rowsPerPage;
        }

        if (isStatusInvalid) {
          isDisable = true;
        } else {
          isDisable = false;
          return false;
        }
        return true;
      });

    if (isDisable) {
      disabledPages.push(page + 1);
      isDisable = false;
    }
  });

  return disabledPages;
};

export const shouldShowGroupedButton = ({
  rows,
  dateChangedIdx,
  getPosName,
}) => {
  return !!rows?.some((row) => {
    const posName = getPosName(row);
    return dateChangedIdx?.[row?.session?._id]?.[posName];
  });
};

export const handleEventContextMenu = ({ event, row, setContextMenu }) => {
  event.preventDefault();
  setContextMenu({
    status: true,
    mouseX: event.clientX + 2,
    mouseY: event.clientY - 6,
    row,
  });
};

/**
 * The whole point of this function to stop form from refreshing the page if user click enter
 */
export const onSubmitFormNoAction = (e) => {
  e.preventDefault();
};

/**
 * get client name for event
 */
export const getClientName = (data) => {
  return data?.companyName || `${data?.firstName} ${data?.lastName}`;
};

/**
 * colors for dashboard
 */
export const dashboardRowBackgroundColors = {
  eventEditedByClient: "#6A61AA", // violet
  allEventContractorsGustoApproved: "#d175b6", // pink
  showFullyBooked: "#00BBC9", // teal
  showSOWInProgress: "#0083CA", // blue
  allEventContractorsPayrollApproved: "#3ded97bd", // seafoam
};

/**
 * list of color reasons
 */
export const colorReasonArray = [
  {
    color: dashboardRowBackgroundColors?.eventEditedByClient,
    reason: "Event is edited by client",
  },
  {
    color: dashboardRowBackgroundColors?.allEventContractorsGustoApproved,
    reason: "Any of the assigned contractors are HR unapproved",
  },
  {
    color: dashboardRowBackgroundColors?.showFullyBooked,
    reason: "An event is fully booked",
  },
  {
    color: dashboardRowBackgroundColors?.showSOWInProgress,
    reason: "Event SOW is in proress",
  },
  {
    color: dashboardRowBackgroundColors?.allEventContractorsPayrollApproved,
    reason: "Any of the assigned contractors are Payroll unapproved",
  },
];

/**
 * Returns the ordered list of stripe colors that apply to a row,
 * using the same precedence as getRowBackgroundStyle.
 */
export const getRowStrips = (row) => {
  const isEdited = row?.eventEditedByClient;
  const isApproved = !isUndefined(row?.areAllContractorGustoApproved)
    ? !row?.areAllContractorGustoApproved
    : false;
  const areAllPayrollApproved = !isUndefined(
    row?.areAllContractorsPayrollApproved,
  )
    ? row?.areAllContractorsPayrollApproved
    : false;
  const status = row?.sowStatus;

  const strips = [];
  if (status === "Fully Booked")
    strips.push({
      color: dashboardRowBackgroundColors.showFullyBooked,
      reason: "An event is fully booked",
    });
  if (status === "SOWs in Progress")
    strips.push({
      color: dashboardRowBackgroundColors.showSOWInProgress,
      reason: "Event SOW is in progress",
    });
  if (isEdited)
    strips.push({
      color: dashboardRowBackgroundColors.eventEditedByClient,
      reason: "Event is edited by client",
    });
  if (isApproved)
    strips.push({
      color: dashboardRowBackgroundColors.allEventContractorsGustoApproved,
      reason: "Any of the assigned contractors are HR unapproved",
    });
  if (!areAllPayrollApproved)
    strips.push({
      color: dashboardRowBackgroundColors.allEventContractorsPayrollApproved,
      reason: "Any of the assigned contractors are Payroll unapproved",
    });

  return strips;
};

export const getRowStripColors = (row) =>
  getRowStrips(row).map((s) => s.color);

/**
 * get row background styles according to status
 */
export const getRowBackgroundStyle = (row) => {
  const isEdited = row?.eventEditedByClient;
  const isApproved = !isUndefined(row?.areAllContractorGustoApproved)
    ? !row?.areAllContractorGustoApproved
    : false;

  const areAllPayrollApproved = !isUndefined(
    row?.areAllContractorsPayrollApproved,
  )
    ? row?.areAllContractorsPayrollApproved
    : false;

  const status = row?.sowStatus;

  const editedByClientColor = dashboardRowBackgroundColors?.eventEditedByClient; // edited by client
  const areGustoApproved =
    dashboardRowBackgroundColors?.allEventContractorsGustoApproved; // For "gusto unapproved"
  const fullyBookedColor = dashboardRowBackgroundColors?.showFullyBooked; // For "Fully Booked"
  // const orange = "#627ce2b0"; // For "SOWs in Progress"
  const sowInProgColor = dashboardRowBackgroundColors?.showSOWInProgress; // For "SOWs in Progress"
  const arePayrollApproved =
    dashboardRowBackgroundColors?.allEventContractorsPayrollApproved;

  // Collect the colors we need to show
  const stripes = [];

  if (status === "Fully Booked") stripes.push(fullyBookedColor);
  if (status === "SOWs in Progress") stripes.push(sowInProgColor);
  if (isEdited) stripes.push(editedByClientColor);
  if (isApproved) stripes.push(areGustoApproved);
  if (!areAllPayrollApproved) stripes.push(arePayrollApproved);

  // If there are any colors to show, build an equal-split gradient
  if (stripes.length > 0) {
    const segmentSize = 100 / stripes.length;
    const gradientStops = [];

    stripes.forEach((color, index) => {
      const start = (index * segmentSize).toFixed(2);
      const end = ((index + 1) * segmentSize).toFixed(2);
      gradientStops.push(`${color} ${start}%`, `${color} ${end}%`);
    });

    return {
      backgroundImage: `linear-gradient(to bottom, ${gradientStops.join(", ")})`,
    };
  }

  // Default case
  return {
    backgroundColor: "transparent",
  };
};

/**
 * function to get title venue
 */
export const getTitleVenueAddress = ({ eventInfo, isSmallScreen }) => {
  if (isSmallScreen) return eventInfo?.venue;
  else
    return `${eventInfo?.venue}, ${eventInfo?.venueCity}, ${eventInfo?.venueState}`;
};

/**
 * get session string
 */
export const getSessionString = ({ positions }) => {
  let shift = 0;
  let positionCount = 0;

  let knownPositions = new Set();

  positions?.map((pos) => {
    if (!knownPositions.has(pos?.positionId)) {
      knownPositions?.add(pos?.positionId);
      positionCount += 1;
    }
    shift += 1;
  });
  return `${positionCount} ${positionCount > 1 ? "Positions" : "Position"} - ${shift} ${shift > 1 ? "Shifts" : "Shift"} `;
};

/**
 * session management position row background color
 */
export const sessionManagementPositionRowReason = [
  {
    color: "#d175b6",
    reason: "Data updated after PO Generation (regeneration needed)",
  },
];

/**
 * estimate color meanings position row text color
 */
export const estimatePositionColorReason = [
  {
    color: "#00EEC5", // green
    reason: "Position added after last estimate generation",
  },

  {
    color: "#face70", // yellow
    reason: "Position edited after last estimate generation",
  },
  {
    color: "#fd355a", // deleted
    reason: "Position deleted after last estimate generation",
  },
  {
    color: "#8a9eed", // violet
    reason:
      "Default rate for this position were not found on the selected rate list",
  },
  {
    color: "#d175b6", // pink
    reason:
      "The default rate and the currently applied of the rate list are differnet",
  },
];